const settings = {
  brandSite: true,
  channels: [
    {
      channel: 'Skagerrak EN',
      locale: 'en-US',
      languageCode: 'en',
      slugs: {
        ContentfulArticlePage: 'articles',
      },
    },
    {
      channel: 'Skagerrak DE',
      locale: 'de-DE',
      languageCode: 'de',
      slugs: {
        ContentfulArticlePage: 'Artikel',
      },
    },
  ],
  localization: {
    default: 'en-US',
    defaultLanguageCode: 'en',
  },
};

export default settings;
